import $ from 'jquery';
import Swal from 'sweetalert2';

/**
 * Handle success/error messages from session
 */
export function handleFlashMessages() {
    const flash = document.getElementById('flash-messages');
    if (!flash) return;

    const success = flash.dataset.success;
    const error = flash.dataset.error;
    const validation = flash.dataset.validation;

    if (success && success.trim() !== "") {
        Swal.fire({
            icon: 'success',
            title: 'Berhasil',
            html: success,
            timer: 3000,
            showConfirmButton: false
        });
    }

    if (error && error.trim() !== "") {
        Swal.fire({
            icon: 'error',
            title: 'Oops...',
            html: error
        });
    }

    if (validation && (validation === 'true' || validation === '1')) {
        Swal.fire({
            icon: 'warning',
            title: 'Validasi Gagal',
            text: 'Harap periksa kembali isian formulir Anda.'
        });
    }
}

/**
 * Reusable wrapper for a Confirmation Dialog
 * @param {Object} options - SweetAlert fire options
 * @returns {Promise} Resolves to the SweetAlert result
 */
export function confirmAction(options = {}) {
    const defaultOptions = {
        title: 'Konfirmasi',
        text: 'Apakah Anda yakin?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#6c757d',
        confirmButtonText: 'Ya, Lanjutkan',
        cancelButtonText: 'Batal'
    };

    return Swal.fire({ ...defaultOptions, ...options });
}

/**
 * Initialize standard delete button action globally
 * Specifically handles .btn-delete-submit
 */
export function initDeleteConfirm() {
    $(document).on('click', '.btn-delete-submit', function(e) {
        e.preventDefault();
        const $formDelete = $(this).closest('form');
        
        confirmAction({
            title: 'Hapus Data?',
            text: "Data yang dihapus mungkin tidak dapat dikembalikan!",
            confirmButtonColor: '#d33',
            confirmButtonText: 'Ya, Hapus!'
        }).then((result) => {
            if (result.isConfirmed) {
                $formDelete.submit();
            }
        });
    });
}
